<ui-nav-exit-back
  back-action-bottom
  [trackingDetail]="{ event_name: 'loan_dashboard' }"
  infoLabel="Back"
  (exitActionHandler)="backToHome()"
></ui-nav-exit-back>
<ng-container *ngIf="loan; else spinner">
  <section class="loan-dashboard_hader mt-md">
    <brightside-web-account-header
      [title]="'LOAN_DASHBOARD_ACCOUNT_TITLE' | translate : { partnerName: partner.displayName }"
      [balance]="loan.remainingBalance"
      [imageUrl]="partnerImageUrl"
      balanceLabelKey="LOAN_ACCOUNT_REMAINING_AMOUNT"
    >
    </brightside-web-account-header>
  </section>

  <section class="loan-dashboard_content mt-md">
    <bw-action-card-legacy
      *ngIf="[LoanStatus.LOAN_APPROVED, LoanStatus.LOAN_PAID_OFF].includes(loan.status)"
      [cardConfig]="findMoneyCardInfo"
      (ctaClicked)="onFindMoneyCardClick()"
    ></bw-action-card-legacy>
    <brightside-web-loan-dashboard-overview [loan]="loan"></brightside-web-loan-dashboard-overview>
    <brightside-web-loan-dashboard-contact-details [loan]="loan"></brightside-web-loan-dashboard-contact-details>
    <brightside-web-loan-dashboard-disclaimer></brightside-web-loan-dashboard-disclaimer>
  </section>
</ng-container>

<ng-template #spinner>
  <bw-spinner-legacy></bw-spinner-legacy>
</ng-template>
